import { Executor, FromSchema } from '@40seas/entities/common';
import { TenantlessBaseEntity, WithTenantlessBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { FeatureToggleCondition, FeatureToggleConditionSchema } from './feature-toggle.condition';
import { FeatureToggleValue, FeatureToggleValueSchema } from './feature-toggle.value.entity';

export const OrganizationSchema = WithTenantlessBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        name: z.string(),
        conditions: z.array(FeatureToggleConditionSchema).optional(),
        description: z.string().optional(),
        defaultValue: FeatureToggleValueSchema,
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
).strict();

export class FeatureToggle extends FromSchema(OrganizationSchema) implements TenantlessBaseEntity {
    id: string;

    name: string;
    description?: string;
    conditions: FeatureToggleCondition[];

    defaultValue: FeatureToggleValue;

    createdBy?: Executor;
    createdAt: Date;
    updatedAt: Date;
}
